import React, { FC, useCallback } from 'react';

import { EvSection } from '@evinced-private/ui-common';

import { PropertyHelper } from 'src/helpers/PropertyHelper';
import { useConfiguration } from 'src/providers/configurationProvider/ConfigurationProvider';
import { SiteScannerUiToggles } from 'src/services/LocalTogglesService';

import { usePropertySettings } from '../context';
import { setFileType as setFileTypeAction } from '../state';

import { FileTypeSectionBody } from './FileTypeSectionBody';
import { FileTypeSectionHeader } from './FileTypeSectionHeader';
import {
	FILE_TYPE_DESCRIPTION_ID,
	FILE_TYPE_OPTION,
	FILE_TYPE_SETTINGS_TITLE_ID,
	FileTypeOption
} from './FileTypeSettingsV2.constants';
import { toContentTypes } from './FileTypeSettingsV2.helpers';

import '../../../components/property-settings/sections/file-type-settings/FileTypeSettings.scss';

export const FileTypeSettingsV2: FC = () => {
	const { getToggle } = useConfiguration();
	const {
		state: { draft: property },
		dispatch
	} = usePropertySettings();

	const fileType: FileTypeOption =
		property && PropertyHelper.isPdfMode(property) ? FILE_TYPE_OPTION.PDF : FILE_TYPE_OPTION.HTML;

	const handleChange = useCallback(
		(option: FileTypeOption): void => {
			dispatch(setFileTypeAction(toContentTypes(option)));
		},
		[dispatch]
	);

	if (!getToggle(SiteScannerUiToggles.ENABLE_CRAWL_FILE_TYPES_OPTION) || !property) {
		return null;
	}

	return (
		<EvSection
			className="file-type-settings-section"
			ariaLabelledby={FILE_TYPE_SETTINGS_TITLE_ID}
			ariaDescribedby={FILE_TYPE_DESCRIPTION_ID}
		>
			<div className="file-type-settings-content">
				<FileTypeSectionHeader />
				<FileTypeSectionBody fileType={fileType} onChange={handleChange} />
			</div>
		</EvSection>
	);
};
